import { render, staticRenderFns } from "./CommonServerTables.vue?vue&type=template&id=73cdad28&"
import script from "./CommonServerTables.vue?vue&type=script&lang=js&"
export * from "./CommonServerTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports